<app-single-img-header
  [headingLabel]="contentfulService.homePage.singleImageHeader?.fields.headingLabel"
  [heading]="contentfulService.homePage.singleImageHeader?.fields.heading"
  [subheading]="contentfulService.homePage.singleImageHeader?.fields.subHeading"
  [showBreadcrumb]="contentfulService.homePage.singleImageHeader?.fields.showBreadcrumb"
></app-single-img-header>

<!-- Section 4 - SDS-->
<div class="home__background4">
  <div class="container">
    <h3 class="home__header4">{{contentfulService.homePage.header4}}</h3>
    <p class="home__paragraph4">
      {{contentfulService.homePage.paragraph4}}
    </p>
    <div class="home__image-container">
    <div class="row">
      <div class="col-12 col-md-12">
        <p
          class="home__option"
          [ngClass]="selectedSection === 1 ? 'home__option--selected' : 'home__option--unselected'"
          (click)="selectedSection = 1"
        >
          <img *ngIf="selectedSection === 1" class="home__selected-icon" src="assets/icons/circle-gold.png" />
          <span class="home__option-label">{{contentfulService.homePage.codeSnippetBtn1}}</span>
        </p>
    <img class="homegif" src="assets/images/sds_explainer.gif" />
      </div> 
    </div>
  </div>
</div>
</div>

<!-- Section 3 - Mantle empowers -->
  <div class="home__bg3">
  <div class="home__container3 ">
    <div class="container">
      <div class="row">
        <div class="col-10 col-lg-5 col-xl-5" style="text-align: justify;">
          <h2 class="home__header3">{{contentfulService.homePage.header3}}</h2>
          <p class="home__paragraph3">{{contentfulService.homePage.paragraph3}}</p>
        </div>

        <div class="home__posters-container">
          <div *ngFor="let poster of contentfulService.homePage.posters;">
            <div class="home__poster-container ml-md-4">
              <app-poster
                [title]="poster.fields.title"
                [category]="poster.fields.category"
                [style]="poster.fields.style"
                [link]="poster.fields.link"
                [size]="poster.fields.size"
                [actionBtnText]="poster.fields.actionBtnText"
              ></app-poster>
            </div>
          </div>          
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Section 5 - Future proof -->
<!-- <div class="home__background5">
  <div class="container">
    <div class="section text-center">
      <div class="home__section-container5 row">
        <div class="col-12">
          <h4 class="home__header5">{{contentfulService.homePage.header5}}</h4>
          <p class="home__paragraph5">
            {{contentfulService.homePage.paragraph5}}
          </p>
        </div>
      </div>
      <div class="col-12">
        <a href="https://developer.bitcoin.org/reference/" target="_blank">
          <img class="img-crypto" src="../../assets/images/bitcoin-btc-logo.png">
        </a>
        <a href="https://ethereum.org/en/developers/docs/" target="_blank">
          <img class="img-crypto" src="../../assets/images/ethereum-eth-logo.png">
        </a>
        <a href="https://docs.tonalliance.org/" target="_blank">
          <img class="img-crypto" src="../../assets/images/everscale-ever-logo.png">
        </a>
        <a href="https://hyperledger-fabric.readthedocs.io/en/latest/whatis.html" target="_blank"> 
          <img class="img-crypto" src="../../assets/images/Hyperledger-logo.png">
        </a>
        <a href="https://doc.sitecore.com/xp/en/developers/82/sitecore-experience-platform/xdb.html" target="_blank">
          <img class="img-crypto" src="../../assets/images/xdb.png">
        </a>
      </div>
      <div class="col-12">
        <a href="https://docs.pkt.cash/en/latest/" target="_blank"> 
          <img class="img-crypto" src="../../assets/images/pkt.png">
        </a>
        <a href="https://docs.polygon.technology/" target="_blank">
          <img class="img-crypto" src="../../assets/images/polygon-matic-logo.png">
        </a>
        <a href="https://docs.solana.com/" target="_blank">
          <img class="img-crypto" src="../../assets/images/solana-sol-logo.png">
        </a>
        <a href="https://docs.waves.tech/en/" target="_blank">
          <img class="img-crypto" src="../../assets/images/waves-waves-logo.png">
        </a>
        <a href="https://hedera.com/hbar" target="_blank">
          <img class="img-crypto" src="../../assets/images/hedera-hbar-logo.png">
        </a>
      </div>
    </div>
  </div>
</div>

<img src="../../../../assets/images/How_it_works.png" class="rounded mx-auto d-block responsive">

<app-trusted-companies
  [heading]="contentfulService.homePage.trustedCompanies?.fields.heading"
  [companyLogos]="contentfulService.homePage.trustedCompanies?.fields.companyLogos"
></app-trusted-companies>
-->

<!-- Section 6 - Insights-->
<div class="container" style="margin-top:15vh;">
  <a class="home__link" routerLink="/developers/insights">{{contentfulService.homePage.insightsPreview}}</a>
  <div class="inset-section">
    <div class="row">
      <div
        *ngFor="let article of contentfulService.blog$ | async | slice: 0:2; let i = index"
        class="col-12 col-md-6"
        [ngClass]="{ 'mb-3 mb-md-0': i === 0 }"
        style="cursor: pointer;"
      >
        <app-blog-tile
          [image]="article.image.fields.file.url"
          [heading]="article.title"
          [footnote1]="article.category"
          [footnote2]="article.date.split('T')[0]"
          [offset]="true"
          (click)="onClick(i)"
        ></app-blog-tile>
      </div>
    </div>
  </div>
</div>
